var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-log-row"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.notification_count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }